// Artist takedown (remove a live release from stores).
const en = {
  "rel.td.action": "Request takedown",
  "rel.td.title": "Remove release from stores",
  "rel.td.desc": "\"{name}\" will be taken down from Spotify, Apple Music, YouTube Music and all other stores. Your release data stays in your account.",
  "rel.td.reasonLabel": "Why do you want to take it down?",
  "rel.td.reason.rights": "Rights / ownership issue",
  "rel.td.reason.rerelease": "I'll re-release a new version",
  "rel.td.reason.distributor": "Moving to another distributor",
  "rel.td.reason.artistic": "Artistic decision",
  "rel.td.reason.other": "Other",
  "rel.td.noteLabel": "Note for our team",
  "rel.td.notePlaceholder": "Anything we should know? (optional)",
  "rel.td.warning": "Removal can take up to 7 days to reach every platform. Streams, playlist placements and statistics for this release will be lost.",
  "rel.td.ack": "I understand that this release will be removed from all stores.",
  "rel.td.confirm": "Request takedown",
  "rel.td.cancel": "Cancel",
  "rel.td.success": "Takedown requested",
  "rel.td.successDesc": "Our team has been notified. It can take up to 7 days to disappear from all stores.",
  "rel.td.failed": "Takedown request failed",
  "rel.td.requested": "Takedown requested",
};

const tr = {
  "rel.td.action": "Yayından kaldır (Takedown)",
  "rel.td.title": "Yayını mağazalardan kaldır",
  "rel.td.desc": "\"{name}\" Spotify, Apple Music, YouTube Music ve diğer tüm mağazalardan kaldırılacak. Yayın bilgilerin hesabında kalmaya devam eder.",
  "rel.td.reasonLabel": "Neden kaldırmak istiyorsun?",
  "rel.td.reason.rights": "Hak / sahiplik sorunu",
  "rel.td.reason.rerelease": "Yeni bir versiyon yayınlayacağım",
  "rel.td.reason.distributor": "Başka bir distribütöre geçiyorum",
  "rel.td.reason.artistic": "Sanatsal karar",
  "rel.td.reason.other": "Diğer",
  "rel.td.noteLabel": "Ekibimize not",
  "rel.td.notePlaceholder": "Bilmemiz gereken bir şey var mı? (isteğe bağlı)",
  "rel.td.warning": "Kaldırma işleminin tüm platformlara ulaşması 7 güne kadar sürebilir. Bu yayına ait dinlenmeler, playlist yerleşimleri ve istatistikler kaybolur.",
  "rel.td.ack": "Bu yayının tüm mağazalardan kaldırılacağını anlıyorum.",
  "rel.td.confirm": "Kaldırma talebi gönder",
  "rel.td.cancel": "Vazgeç",
  "rel.td.success": "Kaldırma talebi alındı",
  "rel.td.successDesc": "Ekibimize bildirildi. Tüm mağazalardan kalkması 7 güne kadar sürebilir.",
  "rel.td.failed": "Kaldırma talebi gönderilemedi",
  "rel.td.requested": "Kaldırma talep edildi",
};

const es = {
  "rel.td.action": "Solicitar retirada",
  "rel.td.title": "Retirar lanzamiento de las tiendas",
  "rel.td.desc": "\"{name}\" se retirará de Spotify, Apple Music, YouTube Music y todas las demás tiendas. Los datos del lanzamiento permanecen en tu cuenta.",
  "rel.td.reasonLabel": "¿Por qué quieres retirarlo?",
  "rel.td.reason.rights": "Problema de derechos / titularidad",
  "rel.td.reason.rerelease": "Publicaré una nueva versión",
  "rel.td.reason.distributor": "Me cambio a otra distribuidora",
  "rel.td.reason.artistic": "Decisión artística",
  "rel.td.reason.other": "Otro",
  "rel.td.noteLabel": "Nota para nuestro equipo",
  "rel.td.notePlaceholder": "¿Algo que debamos saber? (opcional)",
  "rel.td.warning": "La retirada puede tardar hasta 7 días en llegar a todas las plataformas. Se perderán reproducciones, playlists y estadísticas de este lanzamiento.",
  "rel.td.ack": "Entiendo que este lanzamiento se retirará de todas las tiendas.",
  "rel.td.confirm": "Solicitar retirada",
  "rel.td.cancel": "Cancelar",
  "rel.td.success": "Retirada solicitada",
  "rel.td.successDesc": "Nuestro equipo ha sido notificado. Puede tardar hasta 7 días en desaparecer de todas las tiendas.",
  "rel.td.failed": "No se pudo solicitar la retirada",
  "rel.td.requested": "Retirada solicitada",
};

export default { en, tr, es };
